import React, { useState } from 'react'
import { useFormFactor } from '../../../hooks'
import { Trash } from '@phosphor-icons/react'
import { ActionButton, ToggleDescriptionButton } from '../../action-buttons'
import GeneralCard from '../general-card'
import { useStyles } from './styles'
const BookmarksCard = ({ content, testId, onRemove, loading, ...props }) => {
  const { isMobile } = useFormFactor()
  const classes = useStyles()

  const isFullWidth = !isMobile
  // MT.3: description is always visible (no hover reveal). `expanded`
  // starts true regardless of viewport; mobile keeps the
  // ToggleDescriptionButton so users can collapse the subtitle by hand.
  const [expanded, setExpanded] = useState(true)
  const [hoverShadow, setHoverShadow] = useState(false)

  const handleToggleDescription = () => setExpanded(!expanded)
  const handleMouseEnter = () => setHoverShadow(true)
  const handleMouseLeave = () => setHoverShadow(false)

  let actions = {
    leftActions: (
      <>
        <ActionButton
          variant='secondary'
          size='xs'
          label='Remove'
          loading={loading}
          onClick={onRemove}
          startIcon={<Trash size={18} weight='duotone' />}
        />
      </>
    )
  }

  if (!isFullWidth) {
    actions = {
      leftActions: (
        <ToggleDescriptionButton
          size='xs'
          toggled={expanded}
          onClick={handleToggleDescription}
        />
      ),
      rightActions: (
        <>
          <ActionButton
            variant='secondary'
            size='xs'
            label='Remove'
            loading={loading}
            onClick={onRemove}
            startIcon={<Trash size={18} weight='duotone' />}
          />
        </>
      )
    }
  }

  return (
    <GeneralCard
      fullWidth={isFullWidth}
      expand={expanded}
      size={!isFullWidth ? 'mobile' : 'large'}
      hoverShadow={hoverShadow}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      actions={actions}
      content={content}
      testId={testId}
      overrides={{
        summary: isFullWidth && classes.summary,
        actions: isFullWidth && classes.actions,
        card: isFullWidth && classes.card
      }}
      right
      {...props}
    />
  )
}

export default BookmarksCard

// adapt this
